import React from "react";

type ButtonLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: "primary" | "secondary";
};

const cx = (...values: Array<string | undefined>) => values.filter(Boolean).join(" ");

export const ButtonLink: React.FC<ButtonLinkProps> = ({
  className,
  variant = "primary",
  children,
  ...props
}) => (
  <a
    className={cx("ui-btn", variant === "primary" ? "ui-btn-primary" : "ui-btn-secondary", className)}
    {...props}
  >
    {children}
  </a>
);
